import { render, staticRenderFns } from "./DspAdvertiser.vue?vue&type=template&id=21dab784"
import script from "./DspAdvertiser.vue?vue&type=script&lang=js"
export * from "./DspAdvertiser.vue?vue&type=script&lang=js"
import style0 from "./DspAdvertiser.vue?vue&type=style&index=0&id=21dab784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports